module.exports = __webpack_public_path__ + "img/blades.5a6dd709.jpg";